// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"116":"70d47fe8","327":"66e866ff","507":"d08432af","927":"940b393a","952":"1630f117"}[chunkId] + ".chunk.js";
};